import script from "./MallPayHold.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallPayHold.vue?vue&type=script&setup=true&lang=ts"

import "./MallPayHold.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__